import { CSSProperties } from 'react'
import styled from 'styled-components'

import defaultTheme from '../../../infrastructure/themes/theme'
import { IReactSelectStyledState } from '../../../domain/downloads.types'

export const CenterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
  margin: 3rem;
`

export const DownloadDatePickerStyles = styled.div`
  & .react-datepicker {
    border: none;
    font-size: 0.7rem;
    border-radius: 0px;
    border-radius: 10px;
  }
  & .react-datepicker-wrapper {
    background-color: ${defaultTheme.colors.neutralColor700};
    display: inline-block;
    padding: 7px;
    color: lightgray;
    border-color: #fff;
    margin: 10px 20px 0 0;
    border: 1px solid white;
    border-radius: 8px;
    height: 38px;
    min-width: 220px;
  }
  & .react-datepicker__input-container {
    padding-top: 1px;
    padding-left: 4px;
    width: fit-content;
    height: 21px;
  }
  & .react-datepicker__input-container > input {
    background-color: transparent;
    width: 200px;
    vertical-align: baseline;
    border: none;
    color: lightgray;
    font: 0.85em sans-serif;
  }
  & .react-datepicker__input-container > input:focus {
    outline: none;
  }

  & .react-datepicker__close-icon {
    cursor: pointer;
    padding: 0px 2px 0px 7px;
    border-left: 1px solid white;
  }

  & .react-datepicker__close-icon::after {
    cursor: pointer;
    background-color: transparent;
    color: rgb(204, 204, 204);
    padding: 0px;
    font-size: 15px;
    font-weight: bold;
    content: 'x';
  }

  & .react-datepicker__triangle {
    display: none;
  }
  & .react-datepicker__aria-live {
    display: none;
  }
`

export const DownloadSubmitButtonStyles = styled.div`
  & .submit-control {
    border-color: white;
    margin: 28px 20px 0 0;
    border: 1px solid white;
    border-radius: 8px;
    width: 'auto';
    padding: 2px 18px 0;
    height: 38px !important;
    background-color: transparent;
    color: lightgray;
    font: 0.85em sans-serif !important;
    cursor: pointer;
  }
  & .submit-control-disabled {
    border-color: lightgray;
    margin: 28px 20px 0 0;
    border: 1px solid lightgray;
    border-radius: 8px;
    width: 'auto';
    padding: 2px 18px 0;
    height: 38px !important;
    background-color: transparent;
    color: lightgray;
    font: 0.85em sans-serif !important;
    cursor: not-allowed;
  }
`

export const powerPlantSelectCustomStyles = {
  option: (defaultStyles: any) => ({
    ...defaultStyles,
    color: defaultTheme.colors.white,
    backgroundColor: defaultTheme.colors.neutralColor700,
    font: `${defaultTheme.sizes.p} ${defaultTheme.fonts.secondary}`,
  }),
  menu: (defaultStyles: any) => ({
    ...defaultStyles,
    backgroundColor: defaultTheme.colors.neutralColor700,
    border: defaultTheme.colors.none,
  }),
  control: (defaultStyles: any) => ({
    ...defaultStyles,
    backgroundColor: defaultTheme.colors.transparent,
    border: `1px solid ${defaultTheme.colors.white}`,
    margin: '10px 20px 0 0',
    boxShadow: defaultTheme.colors.none,
    borderRadius: '8px',
    minWidth: '220px',
    maxHeight: '25px',
    font: `0.85em ${defaultTheme.fonts.secondary}`,
  }),
  singleValue: (defaultStyles: any) => ({ ...defaultStyles, color: defaultTheme.colors.white }),
  valueContainer: (defaultStyles: any) => ({
    ...defaultStyles,
    color: defaultTheme.colors.white,
  }),
  input: (defaultStyles: any) => ({
    ...defaultStyles,
    color: defaultTheme.colors.white,
  }),
}

export const systemsSelectCustomStyles = {
  option: (defaultStyles: any, state: IReactSelectStyledState) => ({
    ...defaultStyles,
    color: defaultTheme.colors.white,
    backgroundColor: state.isSelected ? defaultTheme.colors.mediumGrey : defaultTheme.colors.none,
    font: `${defaultTheme.sizes.p} ${defaultTheme.fonts.secondary}`,
    lineHeight: '1.2em',
    cursor: 'pointer',
  }),
  menu: (defaultStyles: any) => ({
    ...defaultStyles,
    width: '380px',
    backgroundColor: defaultTheme.colors.neutralColor700,
  }),
  control: (defaultStyles: any) => ({
    ...defaultStyles,
    backgroundColor: defaultTheme.colors.transparent,
    border: `1px solid ${defaultTheme.colors.white}`,
    margin: '10px 20px 0 0',
    boxShadow: defaultTheme.colors.none,
    borderRadius: '8px',
    minWidth: '220px',
    maxHeight: '25px',
    font: `0.85em ${defaultTheme.fonts.secondary}`,
  }),
  valueContainer: (defaultStyles: any) => ({
    ...defaultStyles,
    color: 'red',
    maxHeight: '25px',
    overflowY: 'scroll',
    width: '300px',
  }),
  groupHeading: (defaultStyles: any) => ({
    ...defaultStyles,
    backgoundColor: defaultTheme.colors.blackAlpha70,
  }),
}

export const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: defaultTheme.colors.white,
  cursor: 'pointer',
}

export const groupBadgeStyles: CSSProperties = {
  backgroundColor: defaultTheme.colors.none,
  borderRadius: '2em',
  color: defaultTheme.colors.white,
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16em 0.5em',
  textAlign: 'center',
}
